import React, {Component} from 'react'
// import FJButton from "fj-components/FJButton";
import FJLocalStore from "../../../store/FJLocalStore";
import styles from './FJConfirmModal.module.less';
// import closeSvg from '../../../icon/close.svg';
// import FJButtonCircleIcon from "../button-circle-icon/FJButtonCircleIcon";
import classNames from 'classnames'
import InlineSVG from "react-inlinesvg";
import check from '../../../icon/check.svg';
import key from "keymaster";
import FJClose from "../FJClose/FJClose";
import FJButtonSemicircle from '../button-semicircle/FJButtonSemicircle'

function ModalClose(props) {
  let {
    onClick
  } = props;
  return (
    <div className={styles.close_outer} onClick={onClick}>
      <FJClose />
    </div>
  );
}

// function ModalClose(props) {
//   let {
//     onClick
//   } = props;
//   return (
//     <div className={styles.close}>
//       <FJButtonCircleIcon icon={closeSvg} onClick={onClick} />
//     </div>
//   );
// }

function ModalHeader(props) {
  let {
    text
  } = props;
  return (
    <div className={styles.header}>{text}</div>
  );
}

function ModalBody(props) {
  let {
    text
  } = props;
  return (
    <div className={styles.body}>{text}</div>
  );
}

function ModalFooter(props) {
  let {
    onCancel,
    onSubmit,
    cancelText,
    submitText,
    cancelType,
    submitDanger,
    hasCancel,
    hasSubmit,
    hasNoShowAgain,
    setIsChooseNoShow,
    isChooseNoShow
  } = props;
  let checkClass = classNames(styles.checkbox, isChooseNoShow ? styles.active: null);

  return (
    <div className={styles.footer}>
      <div className={styles.no_show} onClick={setIsChooseNoShow}>
        {
          hasNoShowAgain ?
            <>
              <div className={checkClass}>
                <InlineSVG src={check} element='div' />
              </div>
              <p className={styles.desc}>{FJLocalStore._('do-not-show-again')}</p>
            </> : null
        }
      </div>
      <div>
        {
          hasCancel ? <FJButtonSemicircle size='large' type={cancelType} onClick={onCancel} text={cancelText} className={styles.cancel} /> : null
        }
        {
          hasSubmit ?  <FJButtonSemicircle size='large' danger={!!submitDanger} onClick={onSubmit} text={submitText} className={!submitDanger ? styles.confirm : styles.danger} /> : null
        }
      </div>
    </div>
  );
}

class FJConfirmModal extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isChooseNoShow: false
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.visible !== this.props.visible) {
      if (this.props.visible) {
        key.setScope('');
      } else {
        key.setScope('default');
      }
    }
  }

  /**
   * @description 设置是否选择不再弹出对应的提示框
   * @private
   */
  _setIsChooseNoShow = () => {
    this.setState({
      isChooseNoShow: !this.state.isChooseNoShow
    });
  };

  /**
   * @description 点击submit
   * @private
   */
  _onSubmit = () => {
    this.props.onSubmit(this.state.isChooseNoShow);
    this.setState({
      isChooseNoShow: false
    });
  };

  _onCancel = () => {
    // 判断是否去区别close icon 和退出按钮
    if (this.props.isDistinguishCancel) {
      this.props.onClickOther();
    } else {
      this.props.onCancel();
    }
  };

  render() {
    let {
      onCancel,
      cancelText,
      submitText,
      cancelType,
      submitDanger,
      headerText,
      bodyText,
      hasCancel = true,
      hasSubmit = true,
      hasNoShowAgain = false,
    } = this.props;

    let {isChooseNoShow} = this.state;

    return (
      <div className={styles.container}>
        <ModalClose onClick={() => {onCancel('icon')}} />
        <ModalHeader text={headerText}/>
        <ModalBody text={bodyText}/>
        <ModalFooter cancelText={cancelText || FJLocalStore._('cancel')}
                     submitText={submitText || FJLocalStore._('submit')}
                     onCancel={this._onCancel}
                     onSubmit={this._onSubmit}
                     cancelType={cancelType || 'cancel'}
                     submitDanger={submitDanger}
                     hasCancel={hasCancel}
                     hasSubmit={hasSubmit}
                     hasNoShowAgain={hasNoShowAgain}
                     isChooseNoShow={isChooseNoShow}
                     setIsChooseNoShow={this._setIsChooseNoShow}
        />
      </div>
    );
  }
}

export default FJConfirmModal;
